export default __webpack_public_path__ + "static/media/img-speed-off.d4271bc4.svg";